export const routes = [
  {
    name: "Dashboard",
    to: "/dashboard",
    active: "/dashboard",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/dashboard.svg")}
          // src="https://i.ibb.co/MBv8HPL/Sidebar-icon.png"
          alt="dashboard-icons"
        />
      </span>
    ),
  },
  {
    name: "Entries",
    to: "/entries",
    active: "/entries",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/entries.svg")}
          // src="https://i.ibb.co/MZ8zvYh/entries.png"
          alt="entries-icon"
        />
      </span>
    ),
  },
  // {
  //   name: "Leaderboard",
  //   to: "/leaderboard",
  //   active: "/leaderboard",
  //   icon: (
  //     <span className="mr-3">
  //       <img
  //         width="26px"
  //         height="26px"
  //         src={require("../assets/images/sidebar/rank.svg")}
  //         // src="https://i.ibb.co/MZ8zvYh/entries.png"
  //         alt="entries-icon"
  //       />
  //     </span>
  //   ),
  // },
  {
    name: "Stations & Agents",
    to: "/management/station",
    active: "/management",
    icon: (
      <span className="mr-3 ">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/stations.svg")}
          // src="https://i.ibb.co/DkB45MQ/Sidebar-icon.png"
          alt="stations-agents-icon"
        />
      </span>
    ),
  },

  {
    name: "Social Channels",
    to: "/social-channels",
    active: "/social-channels",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src="https://i.ibb.co/smbHB69/social.png"
          alt=""
        />
      </span>
    ),
  },

  {
    name: "Reports",
    to: "reports",
    active: "/reports",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/reports.svg")}
          alt="service-messaging-icon"
        />
      </span>
    ),
  },
  // {
  //   name: "Insights",
  //   to: "insights",
  //   active: "/insights",
  //   icon: (
  //     <span className="mr-3">
  //       <img
  //         width="20px"
  //         height="20px"
  //         src={require("../assets/images/sidebar/insights.svg")}
  //         alt="service-messaging-icon"
  //       />
  //     </span>
  //   ),
  // },

  {
    name: "Settings",
    to: "/settings",
    active: "/settings",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src="https://i.ibb.co/fXP2ZGG/settings.png"
          alt="dashboard-icons"
        />
      </span>
    ),
  },
];

export const surveyRoutes = [
  {
    name: "Survey",
    to: "/survey-response",
    active: "/survey-response",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/entries.svg")}
          // src="https://i.ibb.co/MZ8zvYh/entries.png"
          alt="entries-icon"
        />
      </span>
    ),
  },

  {
    name: "Reports",
    to: "reports",
    active: "/reports",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/reports.svg")}
          alt="service-messaging-icon"
        />
      </span>
    ),
  },

  {
    name: "Settings",
    to: "/settings",
    active: "/settings",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src="https://i.ibb.co/fXP2ZGG/settings.png"
          alt="dashboard-icons"
        />
      </span>
    ),
  },
];

export const FANMILK = [
  {
    name: "Dashboard",
    to: "/dashboard",
    active: "/dashboard",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/dashboard.svg")}
          // src="https://i.ibb.co/MBv8HPL/Sidebar-icon.png"
          alt="dashboard-icons"
        />
      </span>
    ),
  },
  {
    name: "Entries",
    to: "/entries",
    active: "/entries",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/entries.svg")}
          // src="https://i.ibb.co/MZ8zvYh/entries.png"
          alt="entries-icon"
        />
      </span>
    ),
  },

  {
    name: "Stations & Agents",
    to: "/management/station",
    active: "/management",
    icon: (
      <span className="mr-3 ">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/stations.svg")}
          // src="https://i.ibb.co/DkB45MQ/Sidebar-icon.png"
          alt="stations-agents-icon"
        />
      </span>
    ),
  },

  // {
  //   name: "Service Messaging",
  //   to: "/management/station",
  //   active: "/management/station",
  //   icon: (
  //     <span className="mr-3">
  //       <img
  //         width="20px"
  //         height="20px"
  //         // src="https://i.ibb.co/bW6bKh2/Sidebar-icon.png"
  //         src={require("../assets/images/sidebar/service.svg")}
  //         alt="reports-icon"
  //       />
  //     </span>
  //   ),
  // },
  // {
  //   name: "Social Channels",
  //   to: "/social-channels",
  //   active: "/social-channels",
  //   icon: (
  //     <span className="mr-3">
  //       <img
  //         width="20px"
  //         height="20px"
  //         src="https://i.ibb.co/smbHB69/social.png"
  //         alt=""
  //       />
  //     </span>
  //   ),
  // },

  {
    name: "Reports",
    to: "reports",
    active: "/reports",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/reports.svg")}
          alt="service-messaging-icon"
        />
      </span>
    ),
  },
  {
    name: "Insights",
    to: "insights",
    active: "/insights",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src={require("../assets/images/sidebar/insights.svg")}
          alt="service-messaging-icon"
        />
      </span>
    ),
  },

  {
    name: "Settings",
    to: "/settings",
    active: "/settings",
    icon: (
      <span className="mr-3">
        <img
          width="20px"
          height="20px"
          src="https://i.ibb.co/fXP2ZGG/settings.png"
          alt="dashboard-icons"
        />
      </span>
    ),
  },
];
